<template>
  <!-- <v-card class="appBar"> -->
    <v-app-bar class="overflow-visible"
      color="white"
        dense
        fixed
        >
    
     <v-toolbar-title class="ml-2 title" style=" overflow: visible;">
        Nídia Natal
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tabs
       
       background-color="transparent"
       color="black" right v-if="!$vuetify.breakpoint.xs">
        <!-- <v-tabs-slider color="white"></v-tabs-slider> -->
        <v-tab @click="scrollToElementById(tab.key)" v-for="tab in tabs"  :key="tab.key" >
          <v-icon active-class="active-class" >{{ tab.icon }}</v-icon>
          <div >{{ tab.name }}</div>
        </v-tab>
      </v-tabs>

      <v-tabs 
       background-color="transparent"
       color="black" right v-if="$vuetify.breakpoint.xs">
        <!-- <v-tabs-slider color="white"></v-tabs-slider> -->
        <v-tab @click="scrollToElementById(tab.key)" v-for="tab in tabs"  :key="tab.key" >
          <v-icon active-class="active-class" >{{ tab.icon }}</v-icon>
        </v-tab>
      </v-tabs>
    </v-app-bar>
  <!-- </v-card> -->
</template>


<script>
export default {
  data(){
    return {
      tabs: [
        {name: 'Home', icon: 'mdi-home', key: 'Home'},
        {name: 'D\'ela', icon: 'mdi-bookshelf', key: 'Dela'},
        {name: 'Niarte', icon: 'mdi-shopping', key: 'Niarte'}
      ],
    }
    
  },
  props: {
    tabIndex: {
      type: String,
    },

  },
  methods: {
    /* on click navigate to each tab content */
    scrollToElementById(id) {
       
        const element = document.getElementById(id);

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      

    },
   
  },
  computed: {
    
  },
}
</script>


<style scoped>
.v-app-bar-title {
  min-width: 150px;
  text-align: left;
}

.v-app-bar-title a {
  text-decoration: none;
  color: white;
}

.userBtn {
  background-color: transparent !important;
}

.v-navigation-drawer {
  text-align: left;
}



.v-tab {
  text-transform: capitalize;
  font-size: 1rem;
}

.v-icon {
  margin-right: 5px;
}
</style>